<div class="desktop">
  <ng-container *ngTemplateOutlet="menuTemplate; context: { items: leftItems() }" />
  @if (breadcrumbs(); as breadcrumbs) {
    <ds-breadcrumb [breadcrumbs]="breadcrumbs" />
  }
  <ng-content />
  <ng-container *ngTemplateOutlet="menuTemplate; context: { items: rightItems() }" />
</div>
<div class="mobile">
  @if (!isSingleItem(leftItems())) {
    <div class="main-menu" [class.open]="isMenuOpen()">
      @if (leftItems().length > 0) {
        <ds-button (clickEvent)="toggleMenu()">
          <ds-icon set="rijks" name="menu-2" />
          <span class="sr-only">{{ isMenuOpen() ? "Close menu" : "Menu" }}</span>
        </ds-button>
      }
      @if (breadcrumbs() && showBreadcrumbsOnMobile()) {
        <ds-breadcrumb [breadcrumbs]="breadcrumbs() ?? []" />
      }
      <ng-container *ngTemplateOutlet="menuTemplate; context: { items: rightItems() }" />
    </div>
  } @else {
    <div class="main-menu">
      <ng-container *ngTemplateOutlet="menuTemplate; context: { items: leftItems() }" />
      @if (breadcrumbs() && showBreadcrumbsOnMobile()) {
        <ds-breadcrumb [breadcrumbs]="breadcrumbs() ?? []" />
      }
      <ng-container *ngTemplateOutlet="menuTemplate; context: { items: rightItems() }" />
    </div>
  }
  @if (isMenuOpen()) {
    <ng-container *ngTemplateOutlet="menuTemplate; context: { items: leftItems() }" />
  }
</div>

<ng-template #itemTemplate let-item="item">
  @if (item.icon; as icon) {
    <ds-icon set="rijks" [name]="icon" />
  }
  <span class="label" [class.sr-only]="item.hideLabel === 'always'">
    {{ item.label }}
  </span>
</ng-template>

<ng-template #menuTemplate let-items="items">
  @if (isSingleItem(items) && !items[0].hide) {
    @if (!!items[0].link) {
      <a class="ds-button ds-button--primary" [routerLink]="items[0].link" (click)="closeMenu()">
        <ng-container *ngTemplateOutlet="itemTemplate; context: { item: items[0] }" />
      </a>
    }
    @if (!!items[0].action) {
      <ds-button
        [ariaControls]="$safeNavigationMigration(items[0].aria?.controls)"
        [ariaExpanded]="$safeNavigationMigration(items[0].aria?.expanded)"
        [ariaLabel]="items[0].label"
        (clickEvent)="items[0].action(); closeMenu()"
      >
        <ng-container *ngTemplateOutlet="itemTemplate; context: { item: items[0] }" />
      </ds-button>
    }
  } @else {
    <ul cdkMenu [cdkTrapFocus]="isMenuOpen()" [cdkTrapFocusAutoCapture]="isMenuOpen()">
      @for (item of items; track $index) {
        @if (!item.hide) {
          <li>
            @if (!!item.link) {
              <a
                cdkMenuItem
                class="ds-button ds-button--primary"
                [routerLink]="item.link"
                (click)="closeMenu()"
                (keydown)="closeMenuOnEsc($event)"
              >
                <ng-container *ngTemplateOutlet="itemTemplate; context: { item }" />
              </a>
            }
            @if (!!item.action) {
              <ds-button
                cdkMenuItem
                [ariaControls]="$safeNavigationMigration(item.aria?.controls)"
                [ariaExpanded]="$safeNavigationMigration(item.aria?.expanded)"
                [ariaLabel]="item.label"
                (clickEvent)="item.action(); closeMenu()"
                (keydown)="closeMenuOnEsc($event)"
              >
                <ng-container *ngTemplateOutlet="itemTemplate; context: { item }" />
              </ds-button>
            }
          </li>
        }
      }
    </ul>
  }
</ng-template>
